import { ConcreteEncodable } from "./ConcreteEncodable";

import { DealImplEncoder } from "../../encoder/DealImplEncoder";

import * as CubiqTS from "../../index";
import { Deal } from "../Deal";

export class DealImpl extends ConcreteEncodable implements Deal {
  public static enType: string = "com.bcdfx.model.DealImpl";

  /*FID=1*/
  public id: CubiqTS.Long | null = null;
  /*FID=2*/
  public orderId: CubiqTS.Long | null = null;
  /*FID=3*/
  public orderType: CubiqTS.OrderType;
  /*FID=4*/
  public entryUserId: CubiqTS.Long | null = null;
  /*FID=5*/
  public salesGroupId: CubiqTS.Long | null = null;
  /*FID=6*/
  public clientBranchCode: string;
  /*FID=7*/
  public dealtCcy: string;
  /*FID=8*/
  public allocationId: CubiqTS.Long | null = null;
  /*FID=9*/
  public amt1: CubiqTS.BigNumber | null = null;
  /*FID=10*/
  public amt2: CubiqTS.BigNumber | null = null;
  /*FID=11*/
  public creationDate: CubiqTS.moment.Moment | null = null;
  /*FID=12*/
  public dealStateId: CubiqTS.OrderDealState;
  /*FID=13*/
  public spotClientRate: CubiqTS.BigNumber | null = null;
  /*FID=14*/
  public forwardPoints: CubiqTS.BigNumber | null = null;
  /*FID=15*/
  public allInClientRate: CubiqTS.BigNumber | null = null;
  /*FID=16*/
  public spotTraderMargin: CubiqTS.BigNumber | null = null;
  /*FID=17*/
  public spotSalesMargin: CubiqTS.BigNumber | null = null;
  /*FID=18*/
  public forwardSalesMargin: CubiqTS.BigNumber | null = null;
  /*FID=19*/
  public forwardTraderMargin: CubiqTS.BigNumber | null = null;
  /*FID=20*/
  public salesMargin: CubiqTS.BigNumber | null = null;
  /*FID=21*/
  public dealerMargin: CubiqTS.BigNumber | null = null;
  /*FID=22*/
  public spotMarketRate: CubiqTS.BigNumber | null = null;
  /*FID=23*/
  public forwardMarketPoints: CubiqTS.BigNumber | null = null;
  /*FID=24*/
  public forwardMarketRate: CubiqTS.BigNumber | null = null;
  /*FID=25*/
  public fillUserId: CubiqTS.Long | null = null;
  /*FID=26*/
  public localBookId: CubiqTS.Long | null = null;
  /*FID=27*/
  public remoteBookId: CubiqTS.Long | null = null;
  /*FID=28*/
  public valueDate: CubiqTS.moment.Moment | null = null;
  /*FID=29*/
  public valueDateTenor: string;
  /*FID=30*/
  public traderGroupId: CubiqTS.Long | null = null;
  /*FID=31*/
  public productId: string;
  /*FID=32*/
  public isBuy: boolean;
  /*FID=33*/
  public tradeDate: CubiqTS.moment.Moment | null = null;
  /*FID=34*/
  public fixingDate: CubiqTS.moment.Moment | null = null;
  /*FID=35*/
  public clientCode: string;
  /*FID=36*/
  public accountCode: string;
  /*FID=37*/
  public counterPartyCode: string;
  /*FID=38*/
  public entryUserCode: string;
  /*FID=39*/
  public productType: string;
  /*FID=40*/
  public bookingOrderId: CubiqTS.Long | null = null;
  /*FID=41*/
  public strategyId: CubiqTS.Long | null = null;
  /*FID=42*/
  public usdEquivAmt: CubiqTS.BigNumber | null = null;
  /*FID=44*/
  public requestedPx: CubiqTS.BigNumber | null = null;
  /*FID=45*/
  public clientComment: string;
  /*FID=46*/
  public privateComment: string;
  /*FID=47*/
  public fixingCode: string;
  /*FID=48*/
  public confirmedSalesUserId: CubiqTS.Long | null = null;
  /*FID=49*/
  public bookingIds: Array<string> | null = null;
  /*FID=50*/
  public confirmedSalesUserCode: string;
  /*FID=51*/
  public confirmedSalesUserName: string;
  /*FID=52*/
  public fillComment: string;
  /*FID=53*/
  public algoStrategyName: string;
  /*FID=54*/
  public clOrdId: string;
  /*FID=55*/
  public entryDate: CubiqTS.moment.Moment | null = null;
  /*FID=56*/
  public fillUserCode: string;
  /*FID=57*/
  public fillUserName: string;
  /*FID=58*/
  public requestOrderType: CubiqTS.RequestOrderType;
  /*FID=59*/
  public baseCcyCd: string;
  /*FID=60*/
  public nonBaseCcyCd: string;
  /*FID=61*/
  public isInvert: boolean;
  /*FID=62*/
  public entryUserName: string;
  /*FID=63*/
  public aggregateId: CubiqTS.Long | null = null;
  /*FID=64*/
  public triggerBidRate: CubiqTS.BigNumber | null = null;
  /*FID=65*/
  public triggerOfferRate: CubiqTS.BigNumber | null = null;
  /*FID=66*/
  public triggerSide: CubiqTS.RateSideType;
  /*FID=67*/
  public holdStp: boolean;
  /*FID=68*/
  public triggerTime: CubiqTS.moment.Moment | null = null;
  /*FID=69*/
  public manualDealReference: string;
  /*FID=70*/
  public marketBidRateAtFill: CubiqTS.BigNumber | null = null;
  /*FID=71*/
  public marketOfferRateAtFill: CubiqTS.BigNumber | null = null;
  /*FID=72*/
  public componentDetails: Array<CubiqTS.DealComponentDetails> | null = null;
  /*FID=73*/
  public dealConfirmations: Array<CubiqTS.DealConfirmation> | null = null;
  /*FID=74*/
  public localBookName: string;
  /*FID=75*/
  public remoteBookName: string;
  /*FID=76*/
  public fillState: CubiqTS.FillState;
  /*FID=77*/
  public lastMkt: string;
  /*FID=78*/
  public transactTime: CubiqTS.moment.Moment | null = null;
  /*FID=79*/
  public isPrivate: boolean;
  /*FID=80*/
  public clientName: string;
  /*FID=81*/
  public accountName: string;
  /*FID=82*/
  public clientSegment: string;
  /*FID=83*/
  public isClientIsTraderVisible: boolean;
  /*FID=84*/
  public counterPartyDetails: CubiqTS.CounterPartyDetails | null = null;
  /*FID=85*/
  public isClientStraightThroughProcessing: boolean;
  /*FID=86*/
  public clientTraderName: string;
  /*FID=87*/
  public clientTraderId: CubiqTS.Long | null = null;
  /*FID=88*/
  public strategyType: CubiqTS.StrategyType;
  /*FID=89*/
  public clientBranchCd: string;
  /*FID=90*/
  public clientCd: string;
  /*FID=91*/
  public baseCurrencyCd: string;
  /*FID=92*/
  public nonBaseCurrencyCd: string;
  /*FID=93*/
  public customValues: Array<CubiqTS.CustomValue> | null = null;
  /*FID=94*/
  public ownerGroupIds: Array<CubiqTS.Long> | null = null;
  /*FID=95*/
  public lastOwnerGroupIds: Array<CubiqTS.Long> | null = null;
  /*FID=96*/
  public currencyPairs: Array<string> | null = null;
  /*FID=97*/
  public fixingDts: CubiqTS.moment.Moment | null = null;
  /*FID=98*/
  public traderVisibilityOffset: CubiqTS.Long | null = null;
  /*FID=99*/
  public isAggregateDealFg: boolean;
  /*FID=100*/
  public messageId: string;
  /*FID=101*/
  public reqFixingTzCd: string;
  /*FID=102*/
  public currencyPairAndOwners: Array<CubiqTS.BenchmarkVisibilityPairAndOwner> | null = null;
  /*FID=103*/
  public makerDealRef: string;
  /*FID=104*/
  public secondaryMakerDealRef: string;
  /*FID=105*/
  public marketMidRateAtFill: CubiqTS.BigNumber | null = null;
  /*FID=106*/
  public channelCd: string;
  /*FID=107*/
  public traderGroupNm: string;
  /*FID=108*/
  public salesGroupNm: string;
  /*FID=109*/
  public clientBookingCd: string;
  /*FID=110*/
  public accountBookingCd: string;
  /*FID=111*/
  public externalMarketRt: CubiqTS.BigNumber | null = null;
  /*FID=112*/
  public aggregationType: CubiqTS.AggregationType;
  /*FID=113*/
  public alternateAccountCode: string;
  /*FID=114*/
  public executionType: CubiqTS.ExecutionType;
  /*FID=115*/
  public oboClient: string;
  /*FID=116*/
  public oboAccount: string;
  /*FID=117*/
  public dealRef: string;
  /*FID=118*/
  public orderRef: string;
  /*FID=119*/
  public allocationRef: string;
  /*FID=120*/
  public oboEntryUser: string;
  /*FID=121*/
  public strategyRef: string;
  /*FID=122*/
  public modifyUsers: Array<string> | null = null;
  /*FID=123*/
  public dealUpdateTypeId: CubiqTS.DealUpdateTypeId;
  /*FID=124*/
  public nettingId: string;
  /*FID=125*/
  public benchmarkOrderType: CubiqTS.BenchmarkOrderType;
  /*FID=126*/
  public alternateLastMkt: string;
  /*FID=127*/
  public spotReservationFg: boolean;
  /*FID=128*/
  public spotDealId: CubiqTS.Long | null = null;
  /*FID=129*/
  public aggregateRef: string;
  /*FID=130*/
  public spotDealRef: string;
  /*FID=131*/
  public reqFixingTime: string;
  /*FID=132*/
  public reqFixingDate: string;
  /*FID=133*/
  public fwdNettingId: string;
  /*FID=134*/
  public previousFixingDts: CubiqTS.moment.Moment;
  /*FID=135*/
  public previousTraderVisibilityOffset: CubiqTS.Long;

  constructor() {
    super();
    this.encoder = DealImplEncoder.Instance;
    this.setEncodableType(DealImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "DealImpl[" +
      "id=" +
      this.id +
      "orderId=" +
      this.orderId +
      "orderType=" +
      this.orderType +
      "entryUserId=" +
      this.entryUserId +
      "salesGroupId=" +
      this.salesGroupId +
      "clientBranchCode=" +
      this.clientBranchCode +
      "dealtCcy=" +
      this.dealtCcy +
      "allocationId=" +
      this.allocationId +
      "amt1=" +
      this.amt1 +
      "amt2=" +
      this.amt2 +
      "creationDate=" +
      this.creationDate +
      "dealStateId=" +
      this.dealStateId +
      "spotClientRate=" +
      this.spotClientRate +
      "forwardPoints=" +
      this.forwardPoints +
      "allInClientRate=" +
      this.allInClientRate +
      "spotTraderMargin=" +
      this.spotTraderMargin +
      "spotSalesMargin=" +
      this.spotSalesMargin +
      "forwardSalesMargin=" +
      this.forwardSalesMargin +
      "forwardTraderMargin=" +
      this.forwardTraderMargin +
      "salesMargin=" +
      this.salesMargin +
      "dealerMargin=" +
      this.dealerMargin +
      "spotMarketRate=" +
      this.spotMarketRate +
      "forwardMarketPoints=" +
      this.forwardMarketPoints +
      "forwardMarketRate=" +
      this.forwardMarketRate +
      "fillUserId=" +
      this.fillUserId +
      "localBookId=" +
      this.localBookId +
      "remoteBookId=" +
      this.remoteBookId +
      "valueDate=" +
      this.valueDate +
      "valueDateTenor=" +
      this.valueDateTenor +
      "traderGroupId=" +
      this.traderGroupId +
      "productId=" +
      this.productId +
      "isBuy=" +
      this.isBuy +
      "tradeDate=" +
      this.tradeDate +
      "fixingDate=" +
      this.fixingDate +
      "clientCode=" +
      this.clientCode +
      "accountCode=" +
      this.accountCode +
      "counterPartyCode=" +
      this.counterPartyCode +
      "entryUserCode=" +
      this.entryUserCode +
      "productType=" +
      this.productType +
      "bookingOrderId=" +
      this.bookingOrderId +
      "strategyId=" +
      this.strategyId +
      "usdEquivAmt=" +
      this.usdEquivAmt +
      "requestedPx=" +
      this.requestedPx +
      "clientComment=" +
      this.clientComment +
      "privateComment=" +
      this.privateComment +
      "fixingCode=" +
      this.fixingCode +
      "confirmedSalesUserId=" +
      this.confirmedSalesUserId +
      "bookingIds=" +
      this.bookingIds +
      "confirmedSalesUserCode=" +
      this.confirmedSalesUserCode +
      "confirmedSalesUserName=" +
      this.confirmedSalesUserName +
      "fillComment=" +
      this.fillComment +
      "algoStrategyName=" +
      this.algoStrategyName +
      "clOrdId=" +
      this.clOrdId +
      "entryDate=" +
      this.entryDate +
      "fillUserCode=" +
      this.fillUserCode +
      "fillUserName=" +
      this.fillUserName +
      "requestOrderType=" +
      this.requestOrderType +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonBaseCcyCd=" +
      this.nonBaseCcyCd +
      "isInvert=" +
      this.isInvert +
      "entryUserName=" +
      this.entryUserName +
      "aggregateId=" +
      this.aggregateId +
      "triggerBidRate=" +
      this.triggerBidRate +
      "triggerOfferRate=" +
      this.triggerOfferRate +
      "triggerSide=" +
      this.triggerSide +
      "holdStp=" +
      this.holdStp +
      "triggerTime=" +
      this.triggerTime +
      "manualDealReference=" +
      this.manualDealReference +
      "marketBidRateAtFill=" +
      this.marketBidRateAtFill +
      "marketOfferRateAtFill=" +
      this.marketOfferRateAtFill +
      "componentDetails=" +
      this.componentDetails +
      "dealConfirmations=" +
      this.dealConfirmations +
      "localBookName=" +
      this.localBookName +
      "remoteBookName=" +
      this.remoteBookName +
      "fillState=" +
      this.fillState +
      "lastMkt=" +
      this.lastMkt +
      "transactTime=" +
      this.transactTime +
      "isPrivate=" +
      this.isPrivate +
      "clientName=" +
      this.clientName +
      "accountName=" +
      this.accountName +
      "clientSegment=" +
      this.clientSegment +
      "isClientIsTraderVisible=" +
      this.isClientIsTraderVisible +
      "counterPartyDetails=" +
      this.counterPartyDetails +
      "isClientStraightThroughProcessing=" +
      this.isClientStraightThroughProcessing +
      "clientTraderName=" +
      this.clientTraderName +
      "clientTraderId=" +
      this.clientTraderId +
      "strategyType=" +
      this.strategyType +
      "clientBranchCd=" +
      this.clientBranchCd +
      "clientCd=" +
      this.clientCd +
      "baseCurrencyCd=" +
      this.baseCurrencyCd +
      "nonBaseCurrencyCd=" +
      this.nonBaseCurrencyCd +
      "customValues=" +
      this.customValues +
      "ownerGroupIds=" +
      this.ownerGroupIds +
      "lastOwnerGroupIds=" +
      this.lastOwnerGroupIds +
      "currencyPairs=" +
      this.currencyPairs +
      "fixingDts=" +
      this.fixingDts +
      "traderVisibilityOffset=" +
      this.traderVisibilityOffset +
      "isAggregateDealFg=" +
      this.isAggregateDealFg +
      "messageId=" +
      this.messageId +
      "reqFixingTzCd=" +
      this.reqFixingTzCd +
      "currencyPairAndOwners=" +
      this.currencyPairAndOwners +
      "makerDealRef=" +
      this.makerDealRef +
      "secondaryMakerDealRef=" +
      this.secondaryMakerDealRef +
      "marketMidRateAtFill=" +
      this.marketMidRateAtFill +
      "channelCd=" +
      this.channelCd +
      "traderGroupNm=" +
      this.traderGroupNm +
      "salesGroupNm=" +
      this.salesGroupNm +
      "clientBookingCd=" +
      this.clientBookingCd +
      "accountBookingCd=" +
      this.accountBookingCd +
      "externalMarketRt=" +
      this.externalMarketRt +
      "aggregationType=" +
      this.aggregationType +
      "alternateAccountCode=" +
      this.alternateAccountCode +
      "executionType=" +
      this.executionType +
      "oboClient=" +
      this.oboClient +
      "oboAccount=" +
      this.oboAccount +
      "dealRef=" +
      this.dealRef +
      "orderRef=" +
      this.orderRef +
      "allocationRef=" +
      this.allocationRef +
      "oboEntryUser=" +
      this.oboEntryUser +
      "strategyRef=" +
      this.strategyRef +
      "modifyUsers=" +
      this.modifyUsers +
      "dealUpdateTypeId=" +
      this.dealUpdateTypeId +
      "nettingId=" +
      this.nettingId +
      "benchmarkOrderType=" +
      this.benchmarkOrderType +
      "alternateLastMkt=" +
      this.alternateLastMkt +
      "spotReservationFg=" +
      this.spotReservationFg +
      "spotDealId=" +
      this.spotDealId +
      "aggregateRef=" +
      this.aggregateRef +
      "spotDealRef=" +
      this.spotDealRef +
      "reqFixingTime=" +
      this.reqFixingTime +
      "reqFixingDate=" +
      this.reqFixingDate +
      "fwdNettingId=" +
      this.fwdNettingId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
